import React from 'react';
import { cn } from '../index';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, id, ...props }, ref) => {
    const inputId = id ?? props.name;
    return (
      <label htmlFor={inputId} className={cn('inline-flex items-center gap-2 cursor-pointer select-none', className)}>
        <input
          ref={ref}
          id={inputId}
          type="checkbox"
          className={cn(
            'h-4 w-4 rounded border-[var(--input-border)] text-[var(--primary)]',
            'focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-1',
            'disabled:opacity-50 disabled:cursor-not-allowed',
          )}
          {...props}
        />
        {label && <span className="text-sm text-[var(--fg)]">{label}</span>}
      </label>
    );
  },
);
Checkbox.displayName = 'Checkbox';
